// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","content":"Footer_content__tUe-I","logo":"Footer_logo__w79hm","logo2":"Footer_logo2__xOAiK","socials":"Footer_socials__67pj+"};